module.exports = __webpack_public_path__ + "img/SP-Profi13-Profiles.0aafeb36.jpg";